import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TgRackModule } from '@trademe/tangram';
import { PropertyAgentPromotePageComponent } from './property-agent-promote-page.component';
import { PropertyAgentPromoteSectionModule } from '../../../sections/property-default-sections/property-agent-promote-section/property-agent-promote-section.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TgRackModule,
        PropertyAgentPromoteSectionModule
    ],
    declarations: [PropertyAgentPromotePageComponent],
    exports: [PropertyAgentPromotePageComponent]
})
export class PropertyAgentPromotePageModule {}
